export default "__VITE_ASSET__H87UuM21__"